<!--section about us-->
<div class="section termsrow">
    <div class="container-fluid">
        <div class="row" style="height:360px">
            <div class="col-md-12 text-center">
                <div class="white_fonts">
                    <div class="row animate__animated animate__fadeInUp top">
                        <div class="col-sm-2"></div>
                        <div class="col-sm-8">
                            <header class="section-header">
                                <h3>OSHA INSPECTION PROCEDURES</h3>
                            </header>
                        </div>
                        <div class="col-sm-2"></div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>
<!-- end section -->

<!-- row 1 -->
<div class="section layout_padding">
    <div class="container">
        <div class="row">
            <div class="col-lg-12" data-aos="fade-up" data-aos-delay="300">
                <div class="row"  data-aos="fade-up" data-aos-delay="300">
                    <div class="col-lg-12">
                        <h3 class="theme_color">
                            <strong>Arrival of the Compliance Officer</strong>
                        </h3>

                        <ul class="theme_color fontSize" data-aos="fade-up" data-aos-delay="250">
                            <li><i class="fa fa-circle fontRed facirclesize"></i><span class="mediumFontSize">&nbsp;Verify the Compliance Officer’s credentials—look at ID and business card.</span></li>
                            <li><i class="fa fa-circle fontRed facirclesize"></i><span class="mediumFontSize">&nbsp;Determine why the Compliance Officer wants to inspect the project, i.e. complaint, accident, programmed, imminent danger, follow-up.</span>
                                <ul>
                                    <li style="margin-left: 20px;">
                                        <i class="fa fa-circle-o fontRed facirclesize"></i><span class="mediumFontSize">&nbsp;If a complaint inspection, ask to have a copy of the complaint.</span>
                                    </li>
                                    <li style="margin-left: 20px;">
                                        <i class="fa fa-circle-o fontRed facirclesize"></i><span class="mediumFontSize">&nbsp;If a programmed inspection, ask for a focused inspection.</span>
                                    </li>
                                </ul>
                            </li>
                            <li><i class="fa fa-circle fontRed facirclesize"></i><span class="mediumFontSize">&nbsp;Tell OSHA that your company policy is to contact your Management and SFI Compliance, Inc. prior to starting the inspection. Have OSHA wait in the construction office while you are making phone calls.</span></li>
                            <li><i class="fa fa-circle fontRed facirclesize"></i><span class="mediumFontSize">&nbsp;Call your SFI’s OSHA Hotline or your Safety Consultant immediately</span></li>
                        </ul>
                    </div>
                </div>

                <p></p>
                <div class="row"  data-aos="fade-up" data-aos-delay="300">
                    <div class="col-lg-12">
                        <h3 class="theme_color">
                            <strong>SFI OSHA HOTLINES</strong>
                        </h3>

                        <ul class="theme_color fontSize" data-aos="fade-up" data-aos-delay="250">
                            <li><i class="fa fa-phone fontRed facirclesize"></i><span class="mediumFontSize">&nbsp;<strong>Colorado:</strong> 720-677-6900</span></li>
                            <li><i class="fa fa-phone fontRed facirclesize"></i><span class="mediumFontSize">&nbsp;<strong>Texas:</strong> 214-919-2240</span></li>
                            <li><i class="fa fa-phone fontRed facirclesize"></i><span class="mediumFontSize">&nbsp;<strong>Arizona:</strong> 602-698-7911</span></li>
                            <li><i class="fa fa-phone fontRed facirclesize"></i><span class="mediumFontSize">&nbsp;<strong>Other States:</strong> 800-727-5051 ext. 401</span></li>
                            <li><i class="fa fa-envelope fontRed facirclesize"></i><span class="mediumFontSize">&nbsp;<strong>Email:</strong><a href="mailto:OSHA@sficompliance.com">OSHA@sficompliance.com</a></span></li>

                        </ul>
                    </div>
                </div>

                <p></p>
                <div class="row"  data-aos="fade-up" data-aos-delay="300">
                    <div class="col-lg-12">
                        <p class="theme_color">
                            Brief your SFI Safety Consultant on the situation, and then ask OSHA if they will speak to your SFI Safety Consultant.
                        </p>
                        <p class="theme_color">
                            The following is to be done if a SFI Safety Consultant cannot be at the job when the OSHA inspector conducts the inspection:
                        </p>

                        <ul class="theme_color fontSize" data-aos="fade-up" data-aos-delay="250">
                            <li><i class="fa fa-circle fontRed facirclesize "></i><span class="mediumFontSize">&nbsp;Request an opening conference if the Compliance Officer does not call for one.</span></li>
                            <li><i class="fa fa-circle fontRed facirclesize"></i><span class="mediumFontSize">&nbsp;Have the project superintendent and/or the project manager present.</span></li>
                            <li><i class="fa fa-circle fontRed facirclesize"></i><span class="mediumFontSize">&nbsp;Take detailed notes of everything discussed.</span></li>
                            <li><i class="fa fa-circle fontRed facirclesize"></i><span class="mediumFontSize">&nbsp;Keep all publications and documents given to you by the Compliance Officer and note who gave it to you and the date of its receipt.</span></li>
                            <li><i class="fa fa-circle fontRed facirclesize"></i><span class="mediumFontSize">&nbsp;If more than one Compliance Officer is involved, find out if they plan to make the inspection in one group or split into two or more groups to make the inspection. If they want to divide into two or more groups, tell the Compliance Officer you will have an employer representative with each group.</span></li>
                            <li><i class="fa fa-circle fontRed facirclesize"></i><span class="mediumFontSize">&nbsp;Be cooperative with the Compliance Officer. At all times, prior to, during and after the inspection act in a professional businesslike manner. Never enter personal arguments with the Compliance Officer.</span></li>
                            <li><i class="fa fa-circle fontRed facirclesize"></i><span class="mediumFontSize">&nbsp;Request an opening conference if the Compliance Officer does not call for one.</span></li>
                            <li><i class="fa fa-circle fontRed facirclesize"></i><span class="mediumFontSize">&nbsp;Tell the Compliance Officer that you expect him/her to advise the company of all suspected violations and the standard involved. Tell the Compliance Officer that you will be taking notes of all the suspected violations he/she informs you of so that there will be no dispute as to whether the company was informed.</span></li>

                        </ul>
                    </div>
                </div>

                <p></p>
                <div class="row" data-aos="fade-up" data-aos-delay="300">
                    <div class="col-lg-12">
                        <h3 class="theme_color">
                            Records Review
                        </h3>

                        <ul class="theme_color fontSize" data-aos="fade-up" data-aos-delay="250">
                            <li><i class="fa fa-circle fontRed facirclesize"></i><span class="mediumFontSize">&nbsp;Allow the Compliance Officer to look only at your Site-Specific Safety Program.</span></li>
                            <li><i class="fa fa-circle fontRed facirclesize"></i><span class="mediumFontSize">&nbsp;Do not volunteer to give or let the Compliance Officer look at any safety inspection reports made by SFI Compliance, Inc., insurance carrier, etc. other than those reports required by OSHA (such as scaffolding inspection forms). This includes not giving or letting the Compliance Officer look at any such reports that have been made on subcontractor’s activities.</span></li>
                        </ul>
                    </div>
                </div>

                <p></p>
                <div class="row" data-aos="fade-up" data-aos-delay="300">
                    <div class="col-lg-12">
                        <h3 class="theme_color">
                            Closing Conference
                        </h3>

                        <ul class="theme_color fontSize" data-aos="fade-up" data-aos-delay="250">
                            <li><i class="fa fa-circle fontRed facirclesize"></i><span class="mediumFontSize">&nbsp;Contact your SFI Safety Consultant prior to the closing conference. Have the designated company representative present for the closing conference.</span></li>
                            <li><i class="fa fa-circle fontRed facirclesize"></i><span class="mediumFontSize">&nbsp;Take notes of everything discussed and record what documents were distributed by the Compliance Officer.</span></li>
                            <li><i class="fa fa-circle fontRed facirclesize"></i><span class="mediumFontSize">&nbsp;Make sure that no questions you have concerning the inspection go unanswered. If the Compliance Officer feels that violations exist on the project, find out exactly why they feel that way. Tell them that you are noting every potential violation that they advise may exist so there will be no dispute at a later conference or hearing. Hand the list back and ask if that is everything, ask what other items may exist. If they are unsure or do not list any others, tell them that you are noting that no additional items were included in response to your questions.</span></li>
                            <li><i class="fa fa-circle fontRed facirclesize"></i><span class="mediumFontSize">&nbsp;Don’t give any estimates of abatement time needed to correct any alleged violations.</span></li>
                        </ul>
                        
                    </div>
                </div>

                <p></p>
                <div class="row" data-aos="fade-up" data-aos-delay="300">
                    <div class="col-lg-12">
                        <h3 class="theme_color">
                            After Closing the Conference
                        </h3>

                        <ul class="theme_color fontSize" data-aos="fade-up" data-aos-delay="250">
                            <li><i class="fa fa-circle fontRed facirclesize"></i><span class="mediumFontSize">&nbsp;Prepare a detailed report of your inspect notes. Include photos and any other relevant information. Send report to Dan Johnson via email: dan@sficompliance.com and your management.</span></li>
                            <li><i class="fa fa-circle fontRed facirclesize"></i><span class="mediumFontSize">&nbsp;Keep all notes and pictures taken on file.</span></li>                            
                        </ul>
                        
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>
<!-- end section-->
